<template>
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-nav">
        <a href="#" class="logo-cambio">
            <!-- Logo -->
            <inertia-link href="/">
                <img :src="logo" class="height-logo" v-if="logo">

                <h1 v-else>- Logo -</h1>
            </inertia-link>
        </a>
        <div class="row width-100">
            <div class="col-6 mr-auto cent-vr">
                <p class="date ocul-movile" href="#">{{ dateInfo }}</p>
            </div>

            <div class="col-6 text-end">
                <inertia-link :href="!$page.props.authCheck ? route('user.loginOption') : route('user.account')" class="sin-deco mr-2">
                    <span>
                        <span class="mr-2 text-login color-primary-n" v-if="$page.props.authCheck && getUserName">{{ getUserName | nameFilter }}</span>
                        <span class="mr-2 text-login color-primary-n ocul-movile" v-else>Ingresa</span>

                        <i class="fe-user ic-login color-primary-n"></i>
                    </span>
                </inertia-link>

                <inertia-link :href="$page.props.authCheck ? route('shopping.checkout') : route('user.register')" class="sin-deco">
                    <span>
                        <span class="badge badge-secondary-n bg-noti">{{ getShoppingCartCount }}</span>
                        <span class="bg-ic-cart">
                            <i class="fe-shopping-cart ic-cart color-primary-n"></i>
                        </span>
                    </span>
                </inertia-link>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex';

import filtersMixin from '../../../mixins/filtersMixin';
import fileRootPathMixin from '../../../mixins/fileRootPathMixin';
import itemMainImageMixin from '../../../mixins/itemMainImageMixin';
import { capitalize, userLocale } from '../../../utils';

export default {

    mixins: [

        filtersMixin,
        fileRootPathMixin,
        itemMainImageMixin,

    ],

    data() {

        return {

            logo: null,

            ecommerceName: '',

            aCategories: [],
            aTopCategories: [],
            aNonTopCategories: [],

            // Search
            isSearching: false,
            noSearchResult: false,
            searchTerm: '',

            aSearchResults: [],
            aLastSearches: [],

        };

    },

    computed: {

        ...mapGetters([

            'getShoppingCartCount',
            'getUserName',
            'getUserPhoto',

        ]),

        dateInfo() {

            const date = new Date();
            const locale = userLocale();

            const day = date.toLocaleDateString(locale, { weekday: 'long' });
            const month = date.toLocaleDateString(locale, { month: 'long' });

            return `${capitalize(day)}, ${capitalize(month)} ${date.getDate()} de ${date.getFullYear()}`;

        },

    },

    mounted() {

        this.loadHeaderData();

    },

    methods: {

        loadHeaderData() {

            this.setPageTitle();
            this.loadLogos();

        },

        setPageTitle() {

            const companyData = $.parseJSON(localStorage.getItem('company_data'));

            if (companyData) {

                document.title = companyData.ecommerce_name;

                if (companyData.ecommerce_name.length <= 35) {

                    this.ecommerceName = companyData.ecommerce_name;

                } else {

                    this.ecommerceName = `${companyData.ecommerce_name.substring(0, 32)}...`;

                }

            }

        },

        loadLogos() {

            const logos = $.parseJSON(localStorage.getItem('logos'));

            if (logos && logos.length > 0) {

                // Logo Principal
                const logo = logos.find((l) => l.position == 1);

                if (logo) {

                    this.logo = this.fileRootPath + logo.path;

                }

                // Favicon
                const favicon = logos.find((l) => l.position == 3);

                if (favicon) {

                    $('link[rel="shortcut icon"]').attr('href', this.fileRootPath + favicon.path);

                }

            }

        },

    },

};
</script>
